import React from 'react';
import { Button, Radio, Space, Tooltip } from 'antd';
import type { RadioChangeEvent } from 'antd';
import { TbX } from 'react-icons/tb';
import { COLORS } from '../../../../styles/style';
import { Label } from '@ydistri/ds';
import AsoTooltip from '../../AsoTooltip';

interface StoreTierSelectorProps {
  onChange: (value: number) => void;
  onReset?: () => void;
  value: number;
  forcedValue?: number | null;
  disabled?: boolean;
  computedValue?: number;
  displayTooltip?: boolean;
}

const tierOptions = [1, 2, 3] as const;

const highlightStyle: React.CSSProperties = {
  color: COLORS.PRIMARY,
  border: `1px solid ${COLORS.PRIMARY}`,
  opacity: '60%',
};

const StoreTierSelector: React.FC<StoreTierSelectorProps> = ({
  onChange,
  onReset,
  value,
  forcedValue,
  disabled,
  computedValue,
  displayTooltip = false,
}) => {
  const isForced = forcedValue !== undefined && forcedValue !== null;
  const buttonStyle = isForced ? 'solid' : undefined;

  const handleChange = (e: RadioChangeEvent) => {
    onChange(Number(e.target.value));
  };

  return (
    <Space>
      <Label>Force tier:</Label>
      {displayTooltip && <AsoTooltip tooltipKey="forceTier" />}
      <Radio.Group
        optionType="button"
        buttonStyle={buttonStyle}
        value={String(value)}
        onChange={handleChange}
        disabled={disabled}
      >
        {tierOptions.map(v => (
          <Radio.Button
            key={v}
            value={String(v)}
            style={computedValue === v && forcedValue !== v ? highlightStyle : undefined}
          >
            {v}
          </Radio.Button>
        ))}
      </Radio.Group>
      {onReset && isForced && (
        <Tooltip title="Reset to computed tier">
          <Button type="text" icon={<TbX />} onClick={onReset} disabled={disabled} />
        </Tooltip>
      )}
    </Space>
  );
};

export default StoreTierSelector;
